import React, {useContext,useEffect,useState} from 'react'
import { Box } from "@material-ui/core";
import { useContextoGlobal } from '../Context/contextoGlobal';
import {Main,Axios} from '../Helpers/importacionesComunes'
import DOMPurify from 'dompurify';
import { CheckCircleIcon, XCircleIcon,ArrowDownTrayIcon ,NoSymbolIcon,EyeIcon,LinkIcon,FolderOpenIcon } from '@heroicons/react/24/solid';
import { Spinner, Textarea , Card, Typography, Input, IconButton, Tooltip, DialogFooter, Button, DialogBody, DialogHeader, Dialog,Checkbox } from '@material-tailwind/react';
import { Height } from '@mui/icons-material';

export const MailsEnviados = ()=>{
    const { esCelular,usuario } = useContextoGlobal();
    const [huboError,setHuboError]=useState(false)
    const [emailsEnviados,setEmailsEnviados]=useState([])
    const [cargando,setCargando] = useState(null);

    useEffect(()=>{
        const buscarEmailsEnviados = async ()=>{
            setCargando(true)
            try{
                const {data} = await Axios.get(`${process.env.REACT_APP_API_UAD_BASE}/api/tablasgenerales/emails/listaenvios`) 
                setEmailsEnviados(data)
                setCargando(false)
            }catch(err){
                setHuboError(true)
                setCargando(false)
            }            
        }

    buscarEmailsEnviados()
    },[])

    const openPreview = (html) => {
        const newWindow = window.open();
        newWindow.document.write(html);
        newWindow.document.close();
    };

    if (huboError){
        return <Main center>
                    <div className='flex flex-col justify-center items-center h-[calc(100vh-10rem)]'>
                        <span>Se produjo un error al cargar los datos para esta vista</span>
                    </div>
            </Main>
    }

    if(cargando){
        return <Main> 
                    <div style={{height:'50px'}} className={`flex flex-col justify-center items-center h-[calc(100vh-10rem)] ${esCelular ? 'ml-40' : ''}`}>
                        <Spinner className="h-12 w-12" />
                        <span className="cargando font-semibold text-[15px]">Cargando...</span>
                    </div>
                </Main>
     }

    return <>
                <div className={esCelular ? 'flex flex-col justify-center ... ml-8 md:ml-52' : 'flex flex-col items-center justify-center'}> 
                    <Typography variant="h4" className="flex">
                            Historial de mails enviados (10 últimos)
                    </Typography>
                      <Typography style={{ marginTop: 10, marginBottom: 10 }} variant="subtitle" className="flex">
                            Por favor no realice una nueva campaña de envíos si hay algún proceso en estado:  <span className='text-red-400 ml-1'> PENDIENTE</span>
                    </Typography>
                    <Box>
                           <ListadoEmails esCelular={esCelular} emails={emailsEnviados} openPreview={openPreview}/>    
                    </Box>    
                </div>
            </>
}

const ListadoEmails = ({emails,openPreview,esCelular})=>{

    return   <table className="w-full min-w-max table-auto text-left mt-2">
                    <Thead/>
                    <Tbody
                        openPreview={openPreview}
                        eventosList={emails}
                    />
    </table>
}

const Thead = ()=>{

    //const head = ['ID','Asunto','Fecha','Usuario','Estado','Módulo','Mensaje','OK','ERROR']
    const head = ['ID','Asunto','Fecha','Usuario','Estado','Módulo','Mensaje','e-mails']

    return  <thead>
                <tr>
                    {head.map(title=>{
                        return <th className="border-b border-blue-gray-100 bg-blue-gray-50 p-4">
                              <Typography
                                variant="small"
                                color="blue-gray"
                                className="font-normal leading-none opacity-70"
                            >
                                {title}
                            </Typography>
                        </th>
                    })}
                </tr>
            </thead>
}

const Tbody = ({eventosList,openPreview})=>{

    return <tbody>
    {eventosList.map((item, index) => {
        const isLast = index === eventosList.length - 1;
        const classes = isLast ? "p-4" : "p-4 border-b border-blue-gray-50";

        return (
            <tr>
                
                 <td className={classes}>
                    <Typography
                        variant="small"
                        color="blue-gray"
                        className="font-normal"
                    >
                        {item.codigo_web}
                    </Typography>
                </td>
                <td className={classes}>
                    <Typography
                        variant="small"
                        color="blue-gray"
                        className="font-normal"
                    >
                        {item.asunto}
                    </Typography>
                </td>
                <td className={classes}>
                    <Typography
                        variant="small"
                        color="blue-gray"
                        className="font-normal"
                    >
                        {item.fecha}
                    </Typography>
                </td>
                <td className={classes}>
                    <Typography
                        variant="small"
                        color="blue-gray"
                        className="font-normal"
                    >
                        {item.usuario}
                    </Typography>
                </td>
                <td className={classes}>
                    <Typography
                        variant="small"
                        color={item.estado==='PENDIENTE' ? "red" : "blue-gray"} 
                        className="font-normal"
                    >
                        {item.estado}
                    </Typography>
                </td>
                 <td className={classes}>
                    <Typography
                        variant="small"
                        color="blue-gray"
                        className="font-normal"
                    >
                        {item.modulo}
                    </Typography>
                </td>
                 <td className={`text-center`}>
                    <div onClick={(e)=>e.preventDefault()} style={{zoom:'0.3',maxWidth:'500px'}} className={`max-h-[400px] overflow-auto text-center`} dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(item.cuerpo)}}></div>
                    <Tooltip content="Ver el html">
                        <IconButton variant="text" onClick={()=>openPreview(item.cuerpo)}>
                            <EyeIcon  className="h-4 w-4"/>  
                        </IconButton>
                    </Tooltip>
                </td>
                <td className={`${classes} cursor-pointer`} onClick={()=>openPreview(mailsEnviados(item.resultado))}>
                    <Typography
                        variant="small"
                        color="blue-gray"
                        className="font-normal"
                    >
                        {item?.cantidad_mails || 0}
                    </Typography>
                </td>                
                 {/* <td className={classes} onClick={()=>openPreview(calcularResultado(item.resultado,true,true))}>
                    <Typography
                        variant="small"
                        color="blue-gray"
                        className="font-normal"
                    >
                        {calcularResultado(item.resultado,true,false)}
                    </Typography>
                </td>
                <td className={classes} onClick={()=>openPreview(calcularResultado(item.resultado,false,true))}>
                    <Typography
                        variant="small"
                        color="blue-gray"
                        className="font-normal"
                    >
                        {calcularResultado(item.resultado,false,false)}
                    </Typography>
                </td>                 */}
                 {/* <td className={`text-center`}>
                    <Typography
                        variant="small"
                        color="blue-gray"
                        className="font-normal text-center"
                    >
                       {formatearResultado(item.resultado,'accepted')[0]}
                    </Typography>
                    <Tooltip content="Ver la lista de e-mails aceptados">
                        <IconButton variant="text" onClick={()=>openPreview(formatearResultado(item.resultado,'accepted')[1])}>
                            <EyeIcon  className="h-4 w-4"/>  
                        </IconButton>
                    </Tooltip>
                </td>
                 <td className={`text-center`}>
                    <Typography
                        variant="small"
                        color="blue-gray"
                        className="font-normal text-center"
                    >
                       {formatearResultado(item.resultado,'rejected')[0]}
                    </Typography>
                    <Tooltip content="Ver la lista de e-mails rechazados">
                        <IconButton variant="text" onClick={()=>openPreview(formatearResultado(item.resultado,'rejected')[1])}>
                            <EyeIcon  className="h-4 w-4"/>  
                        </IconButton>
                    </Tooltip>
                </td> */}
            </tr>
        );
    })}
</tbody>
}

const formatearResultado = (resultado,campoSalida)=>{
    const objectFromString = JSON.parse(resultado);

    if(objectFromString[campoSalida]){
        const analisis = [objectFromString[campoSalida]?.length ? objectFromString[campoSalida]?.length : 0, generarHTML(objectFromString[campoSalida,campoSalida])] 
        return analisis
    }
    else {
        return [0,null]
    }

}

const calcularResultado = (resultado,exito,mostrarLista)=>{

   if (!resultado) return '?';

   try{
     const objectFromString = JSON.parse(resultado);
     if (!objectFromString) return '?';

     if(!mostrarLista){
         return exito ? `${objectFromString.filter(i=>i?.resultado==='OK')?.length}` : `${objectFromString.filter(i=>i?.resultado==='ERROR')?.length}`
     }else{
        return exito ? `${objectFromString.filter(i=>i?.resultado==='OK').map(s=>s?.email || '')}` : `${objectFromString.filter(i=>i?.resultado==='ERROR').map(s=>s?.email || '')}`
     }
   }catch(err){
        return '?'
   }
}

const mailsEnviados = (resultado)=>{

   if (!resultado) return '?';

   try{
     const objectFromString = JSON.parse(resultado);
     if (!objectFromString) return '?';

     return `${objectFromString.map(s=>s?.email || '')}`

   }catch(err){
        return '?'
   }
}

const generarHTML = (mails,tipo) => {
    const traduccion = tipo=='rejected' ? 'rechazados' : 'aceptados'
    if (Array.isArray(mails)) {
        return `
<!DOCTYPE html>
<html>
  <head>
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <style>
      /* Centrar el contenido en el medio de la vista */
      body, html {
        height: 100%;
        margin: 0;
        display: flex;
        justify-content: center;
        margin-top:1.5rem;
        font-family: Arial, sans-serif;
      }

      /* Estilos para la tabla */
      table {
        border-collapse: collapse;
        width: 50%;
        text-align: center;
      }

      td {
        padding: 10px;
        border: 1px solid #ddd;
      }

      /* Estilo de la tabla y los links */
      .vertical-menu {
        width: 200px;
      }
      .vertical-menu a {
        background-color: #eee;
        color: black;
        display: block;
        padding: 12px;
        text-decoration: none;
      }
      .vertical-menu a:hover {
        background-color: #ccc;
      }
      .vertical-menu a.active {
        background-color: #04AA6D;
        color: white;
      }
    .title{
        margin:2rem;
        text-align:center;
        font-weight:600
    }
    .cenres{
        display:flex;
        flex-direction:column;
        align-items:center
    }    
    </style>
  </head>
  <body>
    <div class="cenres">
       ${!mails?.length ? '<h1 class="title">No hay e-mails para mostrar</h1>' : `<h1 class="title">Listado de e-mails ${traduccion}:</h1>`}
        <table>
        ${mails.map(m => `<tr><td>${m}</td></tr>`).join('')}
      </table>
    </div>
  </body>
</html>`;
    } else {
        return null;
    }
};

